import { useEffect, useState } from 'preact/hooks';
import {
  FooterResDto,
  FooterLinks,
  FooterService,
} from '@ts/services/footerService';
import { SocialLinks } from '../SocialLinks/SocialLinks';
import { useComponent } from '../preact';
import { NavTopic } from './NavTopic';
import { Icon } from '../Icon/Icon';

type NavKey = 'legal' | 'company' | 'services';

type NavData = {
  key: NavKey;
  title: string;
  links: FooterLinks[] | undefined;
};

export const Footer = ({ footerService = new FooterService() }) => {
  const [footerLinks, setFooterLinks] = useState<FooterResDto>();

  const navData: NavData[] = [
    {
      key: 'legal',
      title: 'Rechtliches',
      links: footerLinks?.legal,
    },
    {
      key: 'company',
      title: 'Unternehmen',
      links: footerLinks?.company,
    },
    {
      key: 'services',
      title: 'Kontakt & Service',
      links: footerLinks?.services,
    },
  ];

  const getLinks = async (service: FooterService): Promise<void> => {
    try {
      const footerLinks = await service.getFooterLinks();

      setFooterLinks(() => footerLinks);
    } catch (error) {
      if (error instanceof Error)
        console.error(`Error getting footer links: ${error.message}`);
    }
  };

  useEffect(() => {
    getLinks(footerService);
  }, []);

  const dateObj = new Date();

  return (
    <footer className="bc-footer">
      <div className="bc-footer__headline">
        <div className="bc-footer__logo">
          <Icon
            iconName="logof"
            width={30}
            height={40}
            title="Kleines Freitag-Logo"
          />
        </div>
        <div className="bc-footer__claim">
          Wir wollen bloß die Welt verändern.
        </div>
      </div>
      <div className="bc-footer__nav">
        {navData.map(({ key, title, links }) => (
          <NavTopic key={key} title={title} links={links} />
        ))}
      </div>

      <div className="bc-footer__trail">
        © {dateObj.getFullYear()} der Freitag Mediengesellschaft mbH & Co. KG
        <SocialLinks
          socialMedia={['facebook', 'twitter', 'instagram', 'youtube']}
        />
      </div>
    </footer>
  );
};

useComponent('.pts-footer', () => {
  return <Footer />;
});
